module.exports = __webpack_public_path__ + "static/media/AzulPng.640b41ce.png";